// window.initMap = function() {
//     var ele = document.getElementById('map');

//     var _default;
//     $.each(window.__map_row__locations, function(k, v) {
//         if (v._default) {
//             _default = v;
//             return false;
//         }
//     });

// 	window.__map_row__map = new google.maps.Map(ele, {
// 		center: {
//             lat: _default.lat,
//             lng: _default.lng
//         },
// 		zoom: 16,
// 		scrollwheel: false,
// 		styles: [
// 		{
// 			featureType: 'all',
// 			stylers: [
// 				{ hue: '#00deff' },
// 				{ saturation: 50 }
// 			]
// 		},{
// 			featureType: 'road.arterial',
// 			elementType: 'geometry',
// 			stylers: [
// 				{ hue: '#fff' },
// 				{ saturation: 50 }
// 			]
// 		},{
// 			featureType: 'poi',
// 			elementType: 'labels',
// 			stylers: [
// 				{ visibility: 'off' }
// 			]
// 		},
// 		{
// 			featureType: 'road',
// 			elementType: 'labels',
// 			stylers: [
// 				{ hue: '#00ffff' },
// 				{ saturation: 50 }
// 			]
// 		},
// 		{
// 			featureType: 'administrative',
// 			elementType: 'labels',
// 			stylers: [
// 				{ hue: '#00ffff' },
// 				{ saturation: 50 }
// 			]
// 		}
// 		]
// 	});

//     $.each(window.__map_row__locations, function(k, v) {
//         var marker = new google.maps.Marker({
//             position: {
//                 lat: v.lat,
//                 lng: v.lng
//             },
//             map: window.__map_row__map,
//             title: 'Kimal',
//             icon: v.icon
//         });
//     });
// }


